export const apiLang = (i18nLang) =>
  (i18nLang || "").toLowerCase().startsWith("ru") ? "ru" : "kk";

export const exportLocale = (i18nLang) => apiLang(i18nLang);

export const pickLabel = (obj, i18nLang, prefix = "label") =>
  obj ? obj[`${prefix}_${apiLang(i18nLang)}`] : "";

const numLocale = (i18nLang) =>
  apiLang(i18nLang) === "ru" ? "ru-RU" : "kk-KZ";

export const fmtNum = (n, i18nLang) =>
  n == null ? "—" : Number(n).toLocaleString(numLocale(i18nLang));

export const fmtPct = (n, i18nLang) =>
  n == null
    ? "—"
    : `${Number(n).toLocaleString(numLocale(i18nLang), {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })}%`;

export const share = (n, total) => (total ? Math.round((n / total) * 100) : 0);
